import { getFeatureFlagsFromServer } from './requests/clients.js';

// Feature flags object depends from the client (subscription) type
// 0 - free, 1 - multi, 2 - pro

let saFeatureFlags = null;

export async function initializeFeatureFlags() {
  saFeatureFlags = await getFeatureFlagsFromServer();
}

export function getTier() {
  if (!saFeatureFlags) {
    return null;
  }
  return saFeatureFlags["tier"].toUpperCase();
}

export async function getFeatureFlags() {
  // if (!saFeatureFlags) {
  //   await initializeFeatureFlags();
  // }
  return saFeatureFlags["tier_feature_flags"];
}

